import React from "react";
import "./Portfolio.css";
import CryptoApp from "../../img/crytoapp.png";
import TodoApp from "../../img/todoapp.png";
import PortfolioApp from "../../img/portfolio.png";
import MusicApp from "../../img/musicapp.png";
import NdasendaPay from "../../img/ndasendaPay.png";
import Farmhut from "../../img/farmhut.png";
import WeFarm from "../../img/wefarm.png";
import Properties from "../../img/propertyQuest.png";
import invoice from "../../img/invoice.png";
import { motion } from "framer-motion";
const Portfolio = () => {
  const projects = [
    {
      title: "Ndasenda Pay",
      image: NdasendaPay,
      url: "https://pay.ndasenda.co.zw/",
      type: "Fintech payment platform",
      description: "A payment experience focused on clarity, trust, and responsive transaction flows.",
      stack: ["Vue", "Payments", "UI"],
      featured: true,
    },
    {
      title: "Farmhut Africa",
      image: Farmhut,
      url: "https://farmhutafrica.com/",
      type: "Agritech marketplace",
      description: "Marketplace experience for agricultural products with practical discovery patterns.",
      stack: ["Web", "Marketplace", "Product"],
      featured: true,
    },
    {
      title: "Property Quest",
      image: Properties,
      url: "https://properties.wcyber.net/",
      type: "Real estate product",
      description: "Property browsing interface with strong visual browsing and lead-generation intent.",
      stack: ["React", "Listings", "UX"],
    },
    {
      title: "Invoice App",
      image: invoice,
      url: "https://invoice-vue-app.netlify.app/",
      type: "Business workflow tool",
      description: "A clean invoicing workflow for creating and managing business documents.",
      stack: ["Vue", "Forms", "Workflow"],
    },
    {
      title: "Crypto App",
      image: CryptoApp,
      url: "https://cryptoapplication.netlify.app",
      type: "Market data interface",
      description: "A market interface for scanning crypto movement and price-focused content.",
      stack: ["React", "API", "Dashboard"],
    },
    {
      title: "WeFarm",
      image: WeFarm,
      url: "https://wefarminc.netlify.app",
      type: "Community platform",
      description: "Community-oriented product surface with a simple, approachable content structure.",
      stack: ["React", "Community", "Content"],
    },
    {
      title: "Portfolio",
      image: PortfolioApp,
      url: "https://sicelositsha.netlify.app/",
      type: "Personal brand site",
      description: "A portfolio system for presenting work, services, and contact pathways.",
      stack: ["React", "Brand", "Responsive"],
    },
    {
      title: "Todo App",
      image: TodoApp,
      url: "https://todo-app-three-mu.vercel.app/",
      type: "Productivity app",
      description: "Task management interface with focused interactions and lightweight state.",
      stack: ["React", "State", "UX"],
    },
    {
      title: "Music App",
      image: MusicApp,
      url: "https://musicapp-xi.vercel.app/#/",
      type: "Media experience",
      description: "Media UI exploration with playlist-style interaction and visual hierarchy.",
      stack: ["React", "Media", "UI"],
    },
  ];

  return (
    <section className="portfolio" id="portfolio">
      <div className="portfolio-heading">
        <span className="section-kicker">Selected work</span>
        <h2>Recent projects with real product shape.</h2>
      </div>

      <div className="portfolio-grid">
        {projects.map((project, index) => (
          <motion.a
            className={`project-card ${project.featured ? "project-card-featured" : ""}`}
            href={project.url}
            key={project.title}
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.18 }}
            transition={{ duration: 0.45, delay: Math.min(index * 0.05, 0.25) }}
          >
            <div className="project-media">
              <img src={project.image} alt={`${project.title} preview`} />
            </div>
            <div className="project-content">
              <span>{project.type}</span>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-tags">
                {project.stack.map((item) => (
                  <small key={item}>{item}</small>
                ))}
              </div>
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
